<template>

    <div class="layout__container">

        <div class="layout__padding-20px">

            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-50 layout__padding-20-0 layout__border__bottom-light-teal-1px">
                    <h3 class="text__colour-teal">Create New Customer</h3>
                    <!--<div class="layout__padding-20-0 text__colour-grey">(Enter the record details and click to Save Changes or Cancel)</div>-->
                </div>
            </div>

            <el-form :model="customer" ref="customer" :rules="rules" class="layout__position-left layout__width-100">


                <div class="layout__overflow-hidden">
                    <div class="layout__border__all-1px-dotted-cdcfd1 layout__overflow-hidden layout__padding-20px">
                        <div class="text__colour-teal layout__padding-10px-0">
                            Branch Information
                        </div>
                        <div class="component__forms-4 colour__background-light-grey">
                            <div class="layout__padding-0-20">
                                <el-form-item prop="ref" class="">
                                    <div class="component__forms__fields__labels">Branch Code<span class="text__colour-red">*</span></div>
                                    <el-input v-model="customer.ref" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="branchName" class="">
                                    <div class="component__forms__fields__labels">Branch Name</div>
                                    <el-input autofocus v-model="customer.branchName" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="status" class="">
                                    <div class="component__forms__fields__labels">Status</div>
                                    <el-select v-model="customer.status" placeholder="Select Status" clearable="true">
                                        <el-option
                                                v-for="status in ravensworth.customerStatus.options"
                                                :key="status.id"
                                                :label="status.text"
                                                :value="status.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="customerName" class="">
                                    <div class="component__forms__fields__labels">Customer<span class="text__colour-red">*</span>
                                    </div>
                                    <el-input v-model="customer.customerName" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="parentRef" class="">
                                    <div class="component__forms__fields__labels">Head Office</div>
                                    <el-input v-model="customer.parentRef" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="brand" class="">
                                    <div class="component__forms__fields__labels">Brand</div>
                                    <el-input v-model="customer.brand" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <div class="layout__padding-10px-0">
                                    <p class="component__forms__fields">Created</p>
                                    <p class="" v-if="this.customer.created">{{this.customer.created}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="component__forms-4">
                            <div class="layout__padding-0-10">
                                <el-form-item prop="address1" class="">
                                    <div class="component__forms__fields__labels">Branch Address<span
                                            class="text__colour-red">*</span></div>
                                    <el-input v-model="customer.address1" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="address2">
                                    <el-input v-model="customer.address2" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="address3">
                                    <el-input v-model="customer.address3" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="town" clas>
                                    <!--<div class="component__forms__fields__labels">Town</div>-->
                                    <el-input v-model="customer.town" class="layout__position-left" placeholder="Town">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="county" class="component__forms__fields">
                                    <!--<div class="component__forms__fields__labels">County</div>-->
                                    <el-input v-model="customer.county" class="layout__position-left" placeholder="County">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="postcode" class="component__forms__fields">
                                    <div class="component__forms__fields__labels">Postcode<span
                                            class="text__colour-red">*</span>
                                    </div>
                                    <el-input v-model="customer.postcode" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="box" class="component__forms__fields">
                                    <div class="component__forms__fields__labels">DX Depot</div>
                                    <el-input v-model="customer.box" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="component__forms-4">
                            <div class="layout__padding-0-10">
                                <el-form-item prop="invoiceAddress">
                                    <span class="component__forms__fields__labels">Invoice Name and Address</span>
                                    <el-input type="textarea" :rows="5" v-model="customer.invoiceAddress"
                                              class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="invoiceFlag">
                                    <div class="component__forms__fields__labels">Invoice Flag<span class="text__colour-red">*</span></div>
                                    <el-select v-model="customer.invoiceFlag" placeholder="Select Invoice Flag" clearable="true">
                                        <el-option
                                                v-for="invoiceFlag in ravensworth.invoiceFlag.options"
                                                :key="invoiceFlag,id"
                                                :label="invoiceFlag.text"
                                                :value="invoiceFlag.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="vatRate" class="">
                                    <div class="component__forms__fields__labels">VAT Rate</div>
                                    <el-select v-model="customer.vatRate" placeholder="Select VAT Rate" clearable="true">
                                        <el-option
                                                v-for="vatRate in ravensworth.vatRate.options"
                                                :key="vatRate.id"
                                                :label="vatRate.text"
                                                :value="vatRate.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="territory">
                                    <div class="component__forms__fields__labels">Territory</div>
                                    <el-select v-model="customer.territory" placeholder="Select Territory" clearable="true">
                                        <el-option
                                                v-for="territory in territories"
                                                :key="territory.name"
                                                :label="territory.name"
                                                :value="territory.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="printProfile">
                                    <div class="component__forms__fields__labels">Print Profile</div>
                                    <el-input v-model="customer.printProfile" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="component__forms-4">
                            <div class="layout__padding-0-10">
                                <el-form-item prop="netsuiteId">
                                    <div class="component__forms__fields__labels">NetSuite ID</div>
                                    <el-input v-model="customer.netsuiteId" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="salesForceId">
                                    <div class="component__forms__fields__labels">Salesforce ID</div>
                                    <el-input v-model="customer.salesForceId" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="sageStatus">
                                    <p class="component__forms__fields__labels">Sage Status</p>
                                    <p class="" v-if="this.customer.sageStatus">
                                        {{this.customer.sageStatus}}</p>
                                    <p class="" v-else>-</p>
                                </el-form-item>
                                <el-form-item prop="software">
                                    <div class="component__forms__fields__labels">Software</div>
                                    <el-select v-model="customer.software" placeholder="Select Software" clearable="true">
                                        <el-option
                                                v-for="software in ravensworth.softwareType.options"
                                                :key="software.id"
                                                :label="software.text"
                                                :value="software.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="type">
                                    <div class="component__forms__fields__labels">Type</div>
                                    <el-select v-model="customer.type" placeholder="Select Type" clearable="true">
                                        <el-option
                                                v-for="type in ravensworth.customerType.options"
                                                :key="type.id"
                                                :label="type.text"
                                                :value="type.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="minQty">
                                    <div class="component__forms__fields__labels">Min Qty</div>
                                    <el-input v-model="customer.minQty" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="layout__display-block layout__overflow-hidden layout__padding-20-0">
                    <div class="component__forms-3">


                        <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
                            <div class="text__colour-teal layout__padding-10px-0">
                                Production Contact
                            </div>
                            <el-form-item prop="productionContact">
                                <div class="component__forms__fields__labels">Production Contact</div>
                                <el-input v-model="customer.productionContact" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="productionTelNo" class="component__forms__fields">
                                <div class="component__forms__fields__labels">Production Telephone</div>
                                <el-input v-model="customer.productionTelNo" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="productionEmail" class="component__forms__fields">
                                <div class="component__forms__fields__labels">Production Email</div>
                                <el-input v-model="customer.productionEmail" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="component__forms-3">


                        <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
                            <div class="text__colour-teal layout__padding-10px-0">
                                Sales Contact
                            </div>
                            <el-form-item prop="salesContact">
                                <div class="component__forms__fields__labels">Sales Contact</div>
                                <el-input v-model="customer.salesContact" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="salesTelNo" class="component__forms__fields">
                                <div class="component__forms__fields__labels">Sales Telephone</div>
                                <el-input v-model="customer.salesTelNo" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="salesEmail" class="component__forms__fields">
                                <div class="component__forms__fields__labels">Sales Email</div>
                                <el-input v-model="customer.salesEmail" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="component__forms-3">


                        <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
                            <div class="text__colour-teal layout__padding-10px-0">
                                Accounts Contact
                            </div>
                            <el-form-item prop="accountsContact">
                                <div class="component__forms__fields__labels">Accounts Contact</div>
                                <el-input v-model="customer.accountsContact" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="accountsTelNo">
                                <div class="component__forms__fields__labels">Accounts Telephone</div>
                                <el-input v-model="customer.accountsTelNo" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="accountsEmail">
                                <div class="component__forms__fields__labels">Invoice Email Address</div>
                                <el-input v-model="customer.accountsEmail" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>

                </div>

                <div class="layout__overflow-hidden">
                    <div class="">
                        <div class="text__colour-teal layout__padding-10px-0">
                            Account Notes
                        </div>
                        <el-form-item prop="notes" class="">
                            <el-input type="textarea" :rows="6" v-model="customer.notes"
                                      class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <p class="component__columns-2 layout__padding-20-0">Last Modified: {{this.customer.modified}}</p>
                    </div>
                </div>


            </el-form>

            <div class="layout__padding-clear text__align-center layout__padding-20-0 colour__background-light-grey">
                <el-button class="button-red button__base__admin layout__margin__right-20px"
                           v-on:click="updateCustomer('customer')">Save Changes
                </el-button>
                <el-button class="button-teal button__base__admin layout__margin__right-20px"
                           v-on:click="cancelChanges()">Cancel Changes
                </el-button>
                <el-button class="button-red button__base__admin" disabled="true">Delete
                </el-button>
                <div id="message"></div>
            </div>


        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "createCustomers",
        mixins: [axios, csvDownloadHelper, dataFormatter, backing],
        data() {
            return {
                customer: {
                    ref: '',
                    address1: '',
                    address2: '',
                    address3: '',
                    town: '',
                    county: '',
                    postcode: '',
                    box: '',
                    invoiceAddress: '',
                    created: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                    modified: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                    branchName: '',
                    status: 'ACTIVE',
                    brand: '',
                    printProfile: '',
                    territory: '',
                    productionContact: '',
                    productionTelNo: '',
                    productionEmail: '',
                    parentRef: '',
                    netsuiteId: '',
                    type: '',
                    vatRate: '',
                    software: '',
                    salesContact: '',
                    salesTelNo: '',
                    salesEmail: '',
                    customerName: '',
                    salesForceId: '',
                    sageStatus: '',
                    invoiceFlag: '',
                    minQty: 30,
                    accountsContact: '',
                    accountsTelNo: '',
                    accountsEmail: '',
                    notes: ''
                },
                territories: [],
                softwares: [],
                vatRates: [],
                invoiceFlags: [],
                statuses: [],
                types: [],
                rules: {
                    ref: [{
                        required: true,
                        message: 'branch code required',
                        trigger: 'blur'
                    }],
                    invoiceFlag: [{
                        required: true,
                        message: 'invoice flag required',
                        trigger: 'blur'
                    }],
                    customerName: [{
                        required: true,
                        message: 'customer name required',
                        trigger: 'blur'
                    }],
                    address1: [{
                        required: true,
                        message: 'address required',
                        trigger: 'blur'
                    }],
                    postcode: [{
                        required: true,
                        message: 'postcode required',
                        trigger: 'blur'
                    }],
                }
            }
        },
        created() {

            this.isUserAuthorised();

            const getTerritories = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/territoryLookup?`
            Axios.get(getTerritories, this.returnHeaderUsingToken())
                .then(response => {
                    this.territories = response.data.value
                })

        },
        methods: {
            updateCustomer(customer) {
                this.$refs[customer].validate((valid) => {
                    if (valid) {
                        console.log('done post')

                        const createPrices = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/Create`

                        console.log(this.customer)

                        const loading = this.$loading({
                            lock: true,
                            text: 'Saving Changes...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        Axios.post(createPrices, this.customer, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)

                                this.customer = response.data.result;
                                window.sessionStorage.setItem('_customerDetails', JSON.stringify(this.customer));

                                document.getElementById("message").innerText = "Customer Successfully Created"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-success', 'layout__display-block')
                                // this.priceCodes = response.data.value
                                loading.close()
                            })
                            .catch(error => {
                                document.getElementById("message").innerText = "There was a problem creating the customer - please try again"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-fail', 'layout__display-block')
                                loading.close()
                            })


                        // todo the axios call
                        // todo take the updated order and put in the order object

                    } else {
                        return false;
                    }
                })
            },
            cancelChanges() {
                this.customer =
                    {
                        ref: '',
                        address1: '',
                        address2: '',
                        address3: '',
                        town: '',
                        county: '',
                        postcode: '',
                        box: '',
                        invoiceAddress: '',
                        created: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                        modified: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                        branchName: '',
                        status: 'ACTIVE',
                        brand: '',
                        printProfile: '',
                        territory: '',
                        productionContact: '',
                        productionTelNo: '',
                        productionEmail: '',
                        parentRef: '',
                        netsuiteId: '',
                        type: '',
                        vatRate: '',
                        software: '',
                        salesContact: '',
                        salesTelNo: '',
                        salesEmail: '',
                        customerName: '',
                        salesForceId: '',
                        sageStatus: '',
                        invoiceFlag: '',
                        minQty: 30,
                        accountsContact: '',
                        accountsTelNo: '',
                        accountsEmail: '',
                        notes: ''
                    }
            }
        }
    };
</script>